var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 20 15","fill":"none","stroke":"#56C0EE","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6 9l6 6 6-6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }